import styled from "styled-components";

export const TagContainer = styled.div`
  background-color: var(--fd-colors-system-info-background-subtle);
  align-items: center;
  align-content: center;
  border-radius: 12px;
  display: flex;
  gap: 4px;
  padding: 0 6px;
  height: 20px;
  max-height: 20px;
  justify-content: center;
  white-space: nowrap;
`;

export const DescriptionContainer = styled.div`
  position: absolute;
  padding: var(--fd-space-space-2);
  background-color: var(--fd-colors-background-layer);
  border-radius: var(--fd-radii-border-radius-020);
  width: 200px;
  box-shadow: var(--fd-shadows-elevations-bottom-low);
  height: auto;
  text-wrap: auto;
  z-index: 10000;
  visibility: hidden;
  opacity: 0;
  transform: scale(0.95) translateY(16px) translateX(-50%);
  transition:
    opacity 200ms ease-in-out,
    transform 200ms cubic-bezier(0.2, 0.8, 0.8, 1);
`;

export const TooltipTrigger = styled.div`
  position: relative;

  &:hover {
    ${DescriptionContainer} {
      visibility: visible;
      opacity: 1;
      transform: scale(1) translateY(0) translateX(-50%);
    }
  }
`;
